import React, { useEffect, useState } from 'react';
import { Zap, ArrowRight, Star, Eye } from 'lucide-react';
export function Hero() {
  const [buyers, setBuyers] = useState(9);
  useEffect(() => {
    const interval = setInterval(() => {
      setBuyers(prev => {
        const change = Math.random() < 0.5 ? 1 : -1;
        const next = prev + change;
        if (next < 7) return 8;
        if (next > 14) return 12;
        return next;
      });
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-57">
      {/* Background Effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-purple-600/20 blur-[120px] rounded-full pointer-events-none" data-id="element-58"></div>
      <div className="absolute top-1/4 right-0 w-96 h-96 bg-blue-600/10 blur-[100px] rounded-full pointer-events-none" data-id="element-59"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-60">
        <div className="max-w-4xl mx-auto text-center" data-id="element-61">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800/50 border border-purple-500/30 text-purple-300 text-sm font-medium mb-8 backdrop-blur-sm" data-id="element-62">
            <span className="flex h-2 w-2 rounded-full bg-green-400 animate-pulse" data-id="element-63"></span>
            <Eye className="w-4 h-4 text-green-400" data-id="element-64" />
            <span className="font-bold text-green-400 tabular-nums" data-id="element-65">
              {buyers}
            </span>{' '}
            personas comprando en este momento!
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-6 tracking-tight" data-id="element-66">
            ¿Cansado de que la inflación se coma tu sueldo?{' '}
            <br className="hidden md:block" data-id="element-67" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-blue-400 to-purple-400 animate-gradient-x" data-id="element-68">
              Generá tus primeros $500 USD al mes
            </span>
            <br className="hidden md:block" data-id="element-69" /> trabajando desde Argentina con
            IA.
          </h1>

          <p className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-70">
            El método exacto para vender servicios digitales al mundo sin
            necesidad de inglés perfecto ni experiencia previa.
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-71">
            <a href="#pricing" className="group relative inline-flex items-center justify-center gap-3 px-8 py-4 bg-green-400 hover:bg-green-300 text-slate-950 font-bold text-lg md:text-xl rounded-xl transition-all duration-300 shadow-[0_0_30px_rgba(74,222,128,0.3)] hover:shadow-[0_0_40px_rgba(74,222,128,0.5)] hover:-translate-y-1 w-full sm:w-auto" data-id="element-72">
              <Zap className="w-6 h-6 fill-slate-950" data-id="element-73" />
              SÍ, QUIERO GANAR EN DÓLARES AHORA
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-74" />
            </a>

            <div className="flex items-center gap-2 text-sm text-slate-400 mt-4" data-id="element-75">
              <div className="flex" data-id="element-76">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-yellow-500 fill-yellow-500" data-id="element-77" />)}
              </div>
              <span data-id="element-78">Más de 2,500 argentinos ya están facturando</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}